// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"de9ffc09","977":"8a23195a"}[chunkId] + ".chunk.js";
};